import type { MiniGamePageConfig } from '@/app/(football)/[team]/mini-game/_context/types';

export const fcanyangConfig: MiniGamePageConfig = {
  game: {
    colors: ['#8021c2', '#fae8c7', '#d560cc', '#ffc31b'],
    background: {
      color: '#ebebeb',
    },
  },
  titleImage: {
    width: 276,
    height: 62,
    alt: 'FC안양 미니게임 타이틀',
    marginTop: 72,
  },
  eventPeriod: {
    endDate: '2026-12-31T23:59:59+09:00',
  },
};
